import { SignInButton, SignUpButton } from "@clerk/clerk-react";
import { Button } from "@/components/ui/button";
import { getRuntimeAuthProvider } from "@/config/auth";
import { useProviderAuth } from "@/hooks/useProviderAuth";
import { LogIn, UserPlus, ArrowRight } from "lucide-react";

type AuthActionButtonsProps = {
  returnTo?: string;
  showSignUp?: boolean;
  size?: "sm" | "default" | "lg";
  signInVariant?: "outline" | "secondary" | "default";
  signInClassName?: string;
  signUpClassName?: string;
  showIcons?: boolean;
  signUpLabel?: string;
};

export function AuthActionButtons({
  returnTo,
  showSignUp = true,
  size = "sm",
  signInVariant = "outline",
  signInClassName,
  signUpClassName,
  showIcons = false,
  signUpLabel = "Sign Up",
}: AuthActionButtonsProps) {
  const provider = getRuntimeAuthProvider();
  const auth = useProviderAuth();

  if (provider === "clerk") {
    return (
      <>
        <SignInButton mode="modal" forceRedirectUrl={returnTo} signUpForceRedirectUrl={returnTo}>
          <Button variant={signInVariant} size={size} className={signInClassName}>
            {showIcons && <LogIn className="mr-2" />}
            Sign In
          </Button>
        </SignInButton>
        {showSignUp && (
          <SignUpButton mode="modal" forceRedirectUrl={returnTo} signInForceRedirectUrl={returnTo}>
            <Button size={size} className={signUpClassName}>
              {showIcons && <UserPlus className="mr-2" />}
              {signUpLabel}
              {showIcons && <ArrowRight className="ml-2" />}
            </Button>
          </SignUpButton>
        )}
      </>
    );
  }

  return (
    <>
      <Button variant={signInVariant} size={size} className={signInClassName} onClick={() => auth.signIn(returnTo)}>
        {showIcons && <LogIn className="mr-2" />}
        Sign In
      </Button>
      {showSignUp && (
        <Button size={size} className={signUpClassName} onClick={() => auth.signUp(returnTo)}>
          {showIcons && <UserPlus className="mr-2" />}
          {signUpLabel}
          {showIcons && <ArrowRight className="ml-2" />}
        </Button>
      )}
    </>
  );
}
